import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Coller — presse-papiers avec page duotone */
export const PasteIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Page menthe au centre */}
      <rect x="8" y="9" width="9" height="11" rx="1.5" fill="var(--equiply-icon-bg)" fillOpacity="0.6" />
      {/* Pince haut */}
      <rect x="9" y="2.5" width="6" height="3.5" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Clipboard */}
      <path
        d="M9 4H6.5A1.5 1.5 0 0 0 5 5.5v15A1.5 1.5 0 0 0 6.5 22h11a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 17.5 4H15"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Lignes sur la page */}
      <path d="M9.5 12h6M9.5 15h5M9.5 18h4" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
PasteIcon.displayName = "PasteIcon";
